import type { Nullish } from "@ca/types/util";

import { locale } from "./local";

export type DistanceUnit = "foot" | "kilometer" | "meter" | "mile" | "nautical-mile" | "foot-per-minute";

export const formatDistance = ({
	distance,
	unit,
}: {
	distance: Nullish<number>;
	unit: DistanceUnit;
}) => {
	if (distance === null || distance === undefined) {
		return "--";
	}

	if (unit === "nautical-mile") {
		const formatter = new Intl.NumberFormat(locale, {
			maximumFractionDigits: 2,
		});

		return `${formatter.format(distance)} nm`;
	}

	const formatter = new Intl.NumberFormat(locale, {
		maximumFractionDigits: 2,
		style: "unit",
		unit: unit,
	});

	return formatter.format(distance);
};